/* eslint-disable import/prefer-default-export */
export enum DefaultProvidersInvitations {
  PROVIDERS_INVITATION_ALL_MANDATORY = "1",
  PROVIDERS_INVITATION_ALL_OPTIONAL = "2",
  PROVIDERS_INVITATION_NONE = "3",
}
